import {createContext} from "react";
import {Menu} from "../rest/requests/Menu";
import {Auth} from "../rest/requests/Auth";
import {Texts} from "../texts";
import {FetchClasses, OrderType} from "../types";
import {OrderFunctions} from "../rest/requests/OrderFunctions";

export type SnackBarData = {
    text: null | string,
    icon: null | string,
    color: "red" | "green" | "yellow"
} | null;

export type SnackBarEvents = {
    success: (n: string) => void,
    error: (n: string) => void,
    info: (n: string) => void
} | null

export type AppConfigContextType = {
    lang: "fa" | "en",
    texts: Texts,
    theme: "light" | "dark",
    color: string,
    fetch: FetchClasses,
    pageHasHeader: boolean,
    branch: number,
    orderType: OrderType,
    snackBarData: {
        data: SnackBarData,
        events: SnackBarEvents
    } | null,
    currentPageTitle: string,
    setIfPageHasHeader: (b: boolean) => void,
    setPageTitle: (t: string) => void,
    setThemeColor: (t: string) => void,
    setThemeName: (t: string) => void,
    tableId: number
}

const AppConfigContext = createContext({
    lang: "fa",
    texts: Texts.instance("fa"),
    theme: "light" as "light" | "dark",
    color: "#4169E1",
    fetch: {
        Menu: new Menu({defaultEvents: null, orderType: "outside", branchId:0,tableId: 0}),
        Auth: new Auth({defaultEvents: null}),
        Order: new OrderFunctions({defaultEvents: null, orderType: "outside", branchId:0, tableId: 0})
    },
    branch: 0,
    tableId: 0,
    snackBarData: null,
    pageHasHeader: false,
    setIfPageHasHeader: (b: boolean) => {
    },
    currentPageTitle: "",
    setPageTitle: (t: string) => {
    }
} as AppConfigContextType);

export default AppConfigContext;